import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import { Close } from 'mdi-material-ui';
import { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import Editor from '../../components/editor';
import { FileUploaderSingle } from '../../components/upload';
import DropzoneWrapper from '../../styles/react-dropzone';


const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const DialogEvent = (props) => {
  const { show, setShow, loadEvents } = props;
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');
  const [files, setFiles] = useState([]);
  const defaultValues = {
    title: '',
    subtitle: ''
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setContent('');
      setFiles([]);
    }
  },[show]);

  const onSubmit = async (data, e) => {
    setLoading(true)

    const [file] = files;
    const formData = new FormData()

    formData.append('title', data.title);
    formData.append('subtitle', data.subtitle);
    formData.append('content', content);
    formData.append('file', file);

    try {
      await apiService.postFormData('/events', formData)
      toast.success('업데이트 되었습니다.')
      loadEvents()
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setShow(false)
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(false)}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="eventform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 4, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                이벤트 추가
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='title'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='제목'
                        id='title'
                        onChange={onChange}
                        placeholder='제목을 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-title'
                      />
                    )}
                  />
                  {errors.title && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='subtitle'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='부제목'
                        id='subtitle'
                        onChange={onChange}
                        placeholder='부제목을 입력해주세요'
                        error={Boolean(errors.subtitle)}
                        aria-describedby='validation-async-subtitle'
                      />
                    )}
                  />
                  {errors.subtitle && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-subtitle'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name='content'
                  control={control}
                  render={({ field: { value } }) => (
                  <Editor 
                    content={value}
                    setContent={setContent} />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <DropzoneWrapper>
                  <FileUploaderSingle files={files} setFiles={setFiles} />
                </DropzoneWrapper>
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="eventform" variant='contained'>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'common.white',
                  width: '20px !important',
                  height: '20px !important',
                  mr: theme => theme.spacing(2)
                }}
              />
            ) : null}
            등록
          </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
            취소
          </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogEvent
